import { render, staticRenderFns } from "./userDepartmentPostSelection.vue?vue&type=template&id=ca6105ec&scoped=true&"
import script from "./userDepartmentPostSelection.vue?vue&type=script&lang=js&"
export * from "./userDepartmentPostSelection.vue?vue&type=script&lang=js&"
import style0 from "./userDepartmentPostSelection.vue?vue&type=style&index=0&id=ca6105ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca6105ec",
  null
  
)

export default component.exports